module.exports = __webpack_public_path__ + "static/media/flags3-light.7f5aba6d.svg";